function initializeMegaMenuToggle() {
  const navMenuList = document.querySelector('nav.header__inline-menu ul');
  const detailElements = document.querySelectorAll('details.mega-menu');

  if (!navMenuList) return;

  const observer = new MutationObserver(() => {
    detailElements.forEach((detail) => {
      if (detail.open) {
        const isMouseOverNav = navMenuList.querySelector(':hover');
        const isMouseOverDetail = detail.querySelector(':hover');
        const isMouseOverOnCurrentItem = navMenuList.querySelector('.mega-menu[open]');
        if (!isMouseOverNav && !isMouseOverDetail && !isMouseOverOnCurrentItem) {
          detail.open = false;
        }
      }
    });
  });

  detailElements.forEach((detail) => {
    observer.observe(detail, { attributes: true, attributeFilter: ['open'] });
  });

  navMenuList.addEventListener('mouseleave', () => {
    detailElements.forEach((detail) => {
      if (detail.open) {
        const isMouseOverNav = navMenuList.querySelector(':hover');
        const isMouseOverDetail = detail.querySelector(':hover');
        if (!isMouseOverNav && !isMouseOverDetail) {
          detail.open = false;
        }
      }
    });
  });
}

const openMegaMenuOnHover = () => {
  const detailsElements = document.querySelectorAll('.list-menu details.mega-menu');

  detailsElements.forEach((detailsElement) => {
    detailsElement.addEventListener('click', (e) => {
      if (e.target.tagName !== 'A') {
        e.preventDefault();
      }
    });
    detailsElement.addEventListener('mouseenter', function () {
      detailsElements.forEach((otherDetails) => {
        if (otherDetails !== detailsElement) {
          otherDetails.removeAttribute('open');
        }
      });
      detailsElement.setAttribute('open', true);
    });

    detailsElement.addEventListener('mouseleave', function () {
      detailsElement.removeAttribute('open');
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initializeMegaMenuToggle();
  openMegaMenuOnHover();
});
